module.exports = "/assets/upload_icon-a6ba00b4a1fee18542490d69faeee4f1.svg";